import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext';
import api from './api/axiosInstance.js';
import { Container, Card, Button, Form, Row, Col } from 'react-bootstrap';
import openPublicPdf from './utils/openPublicPdf';

const TermsConditionsAdmin = () => {
    const { user, setUser } = useContext(UserContext);
    const [agree, setAgree] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const handleAgree = async () => {
        try {
            const res = await api.post(`/api/auth/agree-terms`);

            const updatedUser = res.data.user; // ✅ trust backend copy
            setUser(updatedUser);
            localStorage.setItem('user', JSON.stringify(updatedUser));

            navigate('/ticket-list');
        } catch (err) {
            console.error(err);
            setError('Unable to update agreement. Please try again.');
        }
    };

    return (
        <main className="main-content flex-grow-1 ms-0">
            <Container>
                <Row>
                    {/* Main Content */}
                    <Col lg={4} className='offset-lg-4'>
                        <Card>
                            <Card.Body>
                                <h2 className="mb-3">Terms & Conditions</h2>
                                <p className="mb-5">
                                    By using this website and its services, you agree to abide by the following:
                                </p>
                                <Form>
                                    <Form.Group className="mb-4">
                                        <div className="d-flex align-items-center">
                                            <Form.Check
                                                type="checkbox"
                                                id="agreeCheckbox"
                                                checked={agree}
                                                onChange={() => setAgree(!agree)}
                                                className="me-2"
                                            />
                                            <Form.Label htmlFor="agreeCheckbox" className="mb-0">
                                                I agree to the&nbsp;
                                                <a
                                                    href="/Abroadify-Terms-of-Use.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="mb-5 text-primary"
                                                    onClick={(e) => openPublicPdf(e, '/Abroadify-Terms-of-Use.pdf')}
                                                >
                                                    <strong>Terms of Use</strong>
                                                </a>.
                                            </Form.Label>
                                        </div>
                                    </Form.Group>
                                    <Button
                                        variant="primary"
                                        onClick={handleAgree}
                                        disabled={!agree}
                                        className="w-100 justify-content-center"
                                    >
                                        Continue
                                    </Button>
                                    {error && <p className="mt-3 text-danger text-center">{error}</p>}
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                
            </Container>
        </main>
    );
};

export default TermsConditionsAdmin;
